import {Injectable} from "@angular/core";

@Injectable()
export class IntClickOutsideService {
  isNotExcludeElements(
    target: HTMLElement,
    excludeElementsForClickOutside: Array<HTMLElement> | HTMLElement | null
  ): boolean {
    if(excludeElementsForClickOutside === null || !excludeElementsForClickOutside) {
      return false;
    }
    if(Array.isArray(excludeElementsForClickOutside)) {
      return excludeElementsForClickOutside.every((element) => {
        return !element.contains(target);
      });
    }else{
      return !excludeElementsForClickOutside.contains(target);
    }
  }
}
